/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-17 14:21:40
 *
 *******************************************************/

import React, { Component } from 'react';
import classnames from 'classnames';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  checked: boolean
};

type ComposedProps = Props & WithI18nProps;

class CollectionHeader4 extends Component<ComposedProps> {
  render() {
    const { i18n, checked } = this.props;
    const CollectionHeaderClass = classnames('collection-header-item collection-header-item-4', {
      active: checked
    });

    return (
      <div className={CollectionHeaderClass}>
        <div className="collection-header-item__content">
          <div className="collection-header-item__bg">
            <p className="title">
              {i18n.translate('AdminHTML.ThemeSetting.LayoutModal.collectionHeader_TitleSample')}
            </p>
            <div className="overlay"></div>
          </div>

          <p className="description">
            {i18n.translate(
              'AdminHTML.ThemeSetting.LayoutModal.collectionHeader_DescriptionSample1'
            )}{' '}
            {i18n.translate(
              'AdminHTML.ThemeSetting.LayoutModal.collectionHeader_DescriptionSample2'
            )}
          </p>
        </div>
      </div>
    );
  }
}

export default withI18n()(CollectionHeader4);
